/**
 * Календарь верфи — единая таймзона для «сегодня» на ОБЕИХ сторонах.
 *
 * Надзор ведётся на площадке в Тайчжоу (КНР, UTC+8), и все календарные вопросы
 * системы — «просрочено ли», «какая сейчас отчётная неделя» — решаются по
 * местной дате, а не по зоне сервера или браузера пользователя. Разница с
 * Москвой +5 часов: в 19:00 воскресенья по МСК на верфи уже понедельник и
 * НОВАЯ отчётная неделя.
 *
 * Модуль общий, потому что зону обязаны знать обе стороны: сервер (`todayIso`
 * в `server/lib/date.ts`, расписание cron) и клиент (подсветка текущей недели
 * на Диске). Разъезд зон давал бы сутки расхождения между тем, какую неделю
 * система считает текущей, и тем, какую подсвечивает интерфейс.
 */
export const MWS_SCHEDULE_TIMEZONE = 'Asia/Shanghai';

/**
 * Текущая календарная дата верфи как 'YYYY-MM-DD'.
 * Локаль en-CA даёт ISO-формат; `Intl` есть и в Node, и в браузере.
 */
export function shipyardTodayIso(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: MWS_SCHEDULE_TIMEZONE }).format(now);
}
